import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormBuilder, FormControlName, Validators } from '@angular/forms';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { FCreneaux } from '../model/FCreneaux';
import { Observable } from 'rxjs';
import { RdvService } from '../services/rdv.service';
import { AuthService } from '../providers/auth.service';
import { UsersService } from '../services/users.service';
import { FDemandeCreneaux } from '../model/FDemandeCreneaux';
import * as firebase from 'firebase/app';
import { WeekCreneauxLibre } from '../model/WeekCreneauxLibre'
import { DatePipe } from '@angular/common';
import { FRdv } from '../model/FRdv';
import { Input, Output, EventEmitter  } from '@angular/core';

@Component({
  selector: 'app-form-rdv',
  templateUrl: './form-rdv.component.html',
  styleUrls: ['./form-rdv.component.css']
})
export class FormRdvComponent implements OnInit {

  private _step1: boolean = false;
  private _step2: boolean = true;
  private _step3: boolean = true;
  private _step4: boolean = true;
  private curr: Date;
  private messageImmatriculationRequired;
  private messageDateRequired;
  private messageSiteRequired;
  private displayOption = false;

  private firstday:Date;
  private endDay:Date;
 

  count: number = 0;

  @Output('update')
  change: EventEmitter<number> = new EventEmitter<number>();

  creneauxx : Observable<WeekCreneauxLibre[]>; 
  creneaux: WeekCreneauxLibre[];

  public rdvForm: FormGroup;
  
  private step1() {

    let immatriculation = this.rdvForm.get("immatriculation").value;
    let siteSelected = this.rdvForm.get("selectedSite").value;

    if(immatriculation != null && immatriculation != '' && immatriculation != "" && siteSelected != null && siteSelected != 'siteSelected' && siteSelected != "")
    {
      this._step1 = true;
      this._step2 = false;
      this.messageImmatriculationRequired = "";
      this.messageSiteRequired = "";
      this.rdvForm.get("dateCreneau").patchValue("");
      this.rdvForm.get("idCreneau").patchValue("");
      this.refreshSemaineEnCours();
      this.refreshCreneaux();
    }
    else{
      if(immatriculation == '')
        this.messageImmatriculationRequired = "Veuillez renseigner une immatriculation !";
      if(siteSelected == '')
        this.messageSiteRequired = "Veuillez seléctionner un site !";
    }

    
  }

  private step2() {

    let datee = this.rdvForm.get("dateCreneau").value;
    if(datee != null && datee != '' && datee != "" )
    {
      this._step2 = true;
      this._step3 = false;
      this.messageDateRequired = "";
    }
    else{
      this.messageDateRequired = "Veuillez choisir un créneau horaire !"
    }
   

    
  }
  private step2prec() {
    this._step1 = false;
    this._step2 = true;
  }


  private step3prec() {
    this._step2 = false;
    this._step3 = true;
    this.refreshSemaineEnCours();
    this.refreshCreneaux();
  }

  private step4() {
    this._step1 = false;
    this._step4 = true;
    
  }


  private confirmer() {
   
    firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
      if (userFire) {
          firebase.auth().currentUser.getIdToken(true).then((idToken) => {

              let fCreneaux:FCreneaux = new FCreneaux(this.rdvForm.get("idCreneau").value, this.rdvForm.get("dateCreneau").value, false, this.rdvForm.get("selectedSite").value, false);

              let rdv: FRdv = new FRdv(null, this.rdvForm.get("nom").value, 
              this.rdvForm.get("prenom").value, this.rdvForm.get("immatriculation").value,
              this.rdvForm.get("telephone").value, this.rdvForm.get("email").value, fCreneaux);


              let retour = this.rdvService.setRdv(idToken, userFire.uid, rdv);
          

                        
              // code here

              this.rdvForm.patchValue({"nom": "", 
              "prenom":"",
              "immatriculation":"",
              "telephone":"",
              "email":"",
              "dateCreneau":"",
              "idCreneau":"",
              "selectedSite":""
            });

            this._step3 = true;
            this._step4 = false;

            this.count++;
            this.change.emit(this.count);


        })
      }
    })




  }

  private selectCreneau(idCreneau:Number, dateCreneau:Date){

    this.rdvForm.get("dateCreneau").patchValue(dateCreneau);
    this.rdvForm.get("idCreneau").patchValue(idCreneau);


  }

  constructor(public datepipe: DatePipe, private authService: AuthService, private usersService: UsersService, private rdvService: RdvService, private fb: FormBuilder) { }

  ngOnInit() {



   

    this.rdvForm =  this.fb.group({
      nom:  [''],
      prenom: [''],
      immatriculation: [''],
      telephone: [''],
      email: [''],
      dateCreneau:  [''],
      idCreneau:[''],
      selectedSite:['']
    
    });

    firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
      if (userFire) {
            if(userFire.email == 'martin.bellembois@jdagency.fr')
              this.displayOption = true;
      }
    })
    
    this.refreshSemaineEnCours();

    this.refreshCreneaux();


  }

  private refreshSemaineEnCours()
  {
    this.curr = new Date();
    this.curr.setHours(0,0,0,0);

    this.firstday= new Date(this.curr.setDate(this.curr.getDate() - ((this.curr.getDay() + 6) % 7)));


    this.endDay = new Date(this.curr.setDate(this.firstday.getDate()+6));
  }

  private previousWeek(){

    this.firstday= new Date(this.subDays(this.firstday, 7));
    this.endDay = new Date(this.addDays(this.firstday, 6));
    this.refreshCreneaux();

  }
  private nextWeek(){
    this.firstday= new Date(this.addDays(this.firstday, 7));

   this.endDay = new Date(this.addDays(this.firstday, 6));

    this.refreshCreneaux();
  }





  private addDays(d, qty) {
    var dd = d.getDate();
    var mm = d.getMonth();
    var yyyy = d.getFullYear();
    return new Date(yyyy, mm, dd + qty);
}
   private subDays(d, qty) {
    var dd = d.getDate();
    var mm = d.getMonth();
    var yyyy = d.getFullYear();
    return new Date(yyyy, mm, dd - qty);
  }

  public unlockCreneau(creneau)
  {

    firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
      if (userFire) {
          firebase.auth().currentUser.getIdToken(true).then((idToken) => {
              this.rdvService.unlockCreneau(idToken, userFire.uid,creneau.idCreneau).subscribe(result => {
                creneau.bloque = false;
              });
        })
      }
    })

    
  }
  public lockCreneau(creneau)
  {
    firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
      if (userFire) {
          firebase.auth().currentUser.getIdToken(true).then((idToken) => {
              this.rdvService.lockCreneau(idToken, userFire.uid,creneau.idCreneau).subscribe(result => {
                creneau.bloque = true;
              });
        })
      }
    })
    
  }

  private refreshCreneaux() {

    
   
 //   console.log(this.firstday);
  //  console.log(this.endDay);
    firebase.auth().onAuthStateChanged((userFire:firebase.User) => {
      if (userFire) {
          firebase.auth().currentUser.getIdToken(true).then((idToken) => {

              let demandeCreneaux:FDemandeCreneaux;
              this.datepipe.transform(this.firstday, 'yyyy-MM-dd');
              demandeCreneaux= new FDemandeCreneaux(this.datepipe.transform(this.firstday, 'yyyy-MM-dd'), this.datepipe.transform(this.endDay, 'yyyy-MM-dd'), this.rdvForm.get("selectedSite").value  )
        
              this.creneauxx = this.rdvService.getCreneauxLibre(idToken, userFire.uid, demandeCreneaux);
              this.creneauxx.subscribe(creneaux => { 
                this.creneaux = creneaux;
               
                
          
          })
        })
      }
    })
    

  }

}
